import PREV_TAB_ID from '../constants/analytics/index.js';
import { getStorage } from '../services/browserStorage/index.js';

var addAnalyticsParamsToUrl = function addAnalyticsParamsToUrl(url, params) {
  var tabId = getStorage(PREV_TAB_ID, false);
  var _a = url.split('?'),
    baseUrl = _a[0],
    searchParams = _a[1];
  var newSearchParams = new URLSearchParams(searchParams);
  Object.keys(params).forEach(function (param) {
    newSearchParams.append(param, encodeURIComponent(params[param] || ''));
  });
  if (tabId) {
    newSearchParams.append('source_id', encodeURIComponent(tabId));
  }
  return "".concat(baseUrl, "?").concat(newSearchParams.toString());
};

export { addAnalyticsParamsToUrl as default };
//# sourceMappingURL=index.js.map
